import {useCallback, useEffect} from 'react';
import {useDispatch} from 'react-redux';

import {useAppSelector} from 'redux-stores/reduceApp';

import {collapsedTables, selectTableCollapsed} from './reduceCollapsedTablesUI';

export interface NotebookItemCollapseHook {
  isCollapsed: boolean;
  onToggleCollapsed: () => void;
}

export function useNotebookItemCollapse(
  collapseId?: string,
  shouldCollapseInitially: boolean = false
): NotebookItemCollapseHook {
  const isCollapsed = useAppSelector(
    (state) => collapseId != null && (selectTableCollapsed(state, collapseId) ?? false)
  );

  const dispatch = useDispatch();
  const onToggleCollapsed = useCallback(() => {
    if (collapseId) {
      dispatch(collapsedTables.actions.toggle({id: collapseId}));
    }
  }, [dispatch, collapseId]);

  useEffect(() => {
    if (collapseId) {
      dispatch(collapsedTables.actions.init({id: collapseId, isCollapsed: shouldCollapseInitially}));
    }
  }, [dispatch, collapseId, shouldCollapseInitially]);

  return {
    isCollapsed,
    onToggleCollapsed,
  };
}
